import { render, staticRenderFns } from "./AdminCenter.vue?vue&type=template&id=0cd9ea14&scoped=true&"
import script from "./AdminCenter.vue?vue&type=script&lang=js&"
export * from "./AdminCenter.vue?vue&type=script&lang=js&"
import style0 from "./AdminCenter.vue?vue&type=style&index=0&id=0cd9ea14&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd9ea14",
  null
  
)

export default component.exports